/**
 * Plugins da mesa no cliente: qual plugin edita cada tipo de dado. Os plugins são web
 * (docs/spec/web-plugins.md): cada ficha roda num iframe (web/WebPluginFrame.tsx), e a instalação
 * fica em web/install.ts.
 */
import type { RoomPlugin } from '../shared.js';

/** Plugin da mesa que edita este tipo de dado. */
export function pluginForDataType(plugins: RoomPlugin[], dataType: string | null): RoomPlugin | undefined {
  if (!dataType) return undefined;
  return plugins.find((p) => p.dataTypes.some((d) => d.id === dataType));
}
